import styled from "styled-components"

export const Wrapper = styled.div`
  position:absolute;
  top:${({positionY}) => positionY ? `${positionY}px`: `0px`};
  left:${({positionX}) => positionX ? `${positionX}px`: `0px`};
  width:40px;
  height:40px;
  display:flex;
  justify-content:center;
  align-items:center;
  font-family:helvetica, arial, sans-serif;
  font-size:30px;
  color:black
  background:white;
  border-radius:3px;
  cursor:pointer;
`